






















import { OrderContext } from '@spa/components/pages/order/model/context/order-context'
import { SubscriptionContext } from '@spa/components/pages/order/model/context/subscription/subscription-context'

import { LoadPayload } from '@spa/store/modules/creditcard/actions'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'
import { Route, RouteConfig } from 'vue-router'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { SelectOption, SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { Payment as AvailablePayment, PaymentList } from '@/models/api/payment/payment'
import { PaymentType } from '@/models/app-config/behavior/types'
import { CartScopeEq } from '@/models/cart/group/scope'
import { DateWithoutHour } from '@/models/date-time/date-without-hour'
import PaymentService from '@/services/api/payment'
import { PaymentServiceForSubscription } from '@/services/api/subscription/payment/payment-service-for-subscription'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'
import OptionsValidator from '@/services/payment/options-validator'
import PaymentEditViewModel, { PaymentEditViewModelFactory } from '@spa/components/organisms/order/edit/payment/model/payment-edit-view-model'
import PaymentEdit from '@spa/components/organisms/order/edit/payment/PaymentEdit.vue'
import SelectedPayment from '@spa/components/pages/order/edit/payment/model/selected-payment'
import { toQuery, toScope } from '@spa/components/pages/order/scope-transpiler'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { OrderList, OrderService, OrderSource } from '@spa/services/order'
import store from '@spa/store'
import { CartItem } from '@spa/store/modules/cart/types'
import { CreditcardModel } from '@spa/store/modules/creditcard/types'
import { PayloadSetPaymentToCreditcard, WithApiPayment } from '@spa/store/modules/orderConfirm/actions'
import { Payment } from '@spa/store/modules/orderConfirm/types'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    PaymentEdit,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Index extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  skuId: string

  @Prop({ required: true })
  context: OrderContext

  Status = Status
  pageStatus: Status = Status.Pending
  removeCardStatus: Status = Status.Pending

  showModal: boolean = false
  modalMessage: string = ''

  cardPaymentProvider = getCreditcardPaymentProvierServiceConfig().forSubscription
  orderService = OrderService.create({
    orderSource: OrderSource.asUndefined(),
  })
  paymentService = new PaymentServiceForSubscription(new PaymentService())

  availablePaymentList: PaymentList = PaymentList.empty()
  selected: SelectedPayment = SelectedPayment.empty()

  get isLoading() {
    return this.pageStatus === Status.Loading || this.removeCardStatus === Status.Loading
  }

  get cartItems(): CartItem[] {
    // TODO: カート内商品の選択方法を注入可能な親コンポーネントを実装
    // TODO: カート内商品の選択方法について、単発注文とサブスクリプション契約それぞれで定義を一元化(コンポーネント外部で定義してDI)
    const cartItems: CartItem[] = this.$store.getters['cart/itemsWithFilter'](
      this.filterPurchasableItem
    )

    return cartItems.filter(c => c.skuId === this.skuId)
  }

  get orderList(): OrderList {
    return new OrderList(
      this.orderService.createOrderFromCartItems(this.cartItems, this.deliveryDateForStandardOrder)
    )
  }

  get deliveryDate(): DateWithoutHour | null {
    const deliveryDate = this.$store.state.orderConfirm.deliveryDate

    return _.get(deliveryDate, 'deliveryPlanDate', null)
  }

  get deliveryDateForStandardOrder(): string {
    return this.deliveryDate === null ? '未指定' : this.deliveryDate.formattedDate('YYYY年MM月DD日')
  }

  get creditcards(): CreditcardModel[] {
    return this.$store.state.creditcard.items
  }

  get creditcardError(): { load?: Error } {
    return _.get(this.$store.state.creditcard, 'error')
  }

  get creditcardLoadError(): Error|null {
    return _.get(this.creditcardError, 'load', null)
  }

  get creditcardLoadFailed(): boolean {
    return this.creditcardLoadError !== null
  }

  get paymentType(): PaymentType | '' {
    return this.selected.paymentType
  }

  get payment(): Payment {
    return _.get(this.$store.state.orderConfirm, 'payment')
  }

  get selectedPaymentOptions(): SelectOptionList {
    return this.selected.optionList
  }

  get selectedPaymentTypeIsAllowed(): boolean {
    return this.availablePaymentList.isAvailablePayment(this.paymentType)
  }

  get paymentEditViewModel(): PaymentEditViewModel {
    const factory = new PaymentEditViewModelFactory(
      this.availablePaymentList,
      this.creditcards,
      this.useCreditcard,
      this.removeCreditcard,
      this.navigateToNewCreditCard,
      false
    )
    factory.selectedPaymentId = this.paymentType
    factory.selectedOptions = this.selectedPaymentOptions
    factory.creditCardLoadFailed = this.creditcardLoadFailed
    /**
     * @see https://github.com/my-color/front/issues/5817 1指定の理由
     * @see https://github.com/my-color/front/pull/5819
     */
    factory.creditCardRegisterLimit = 1
    factory.caption = 'お支払い方法を選択してください。'
    factory.cancelButtonLabel = '注文画面に戻る'
    factory.errorMessage = '別のカードをご利用になる場合、登録済みのカードを削除してから再度ご登録ください'
    factory.showCancelButton = !!this.payment

    return factory.create()
  }

  get cancelUrl(): string {
    return this.context.path.confirmPage
  }

  async beforeRouteEnter (to: Route, _from: Route, next) {
    // TODO: ルーティング定義側に移動。
    // 特に強い事情が無ければ、ルーティング定義の方にhook関数として定義を移動する。
    const scope = toScope(to.query.scope as string || '')
    const context = SubscriptionContext.build({ skuId: to.params.sku_id })

    await guardOnCart(scope, context)

    next()
  }

  async created() {
    this.pageStatus = Status.Loading

    await this.$store.dispatch('cart/load')
    await this.fetchAvailablePaymentList()

    await this.reloadCreditCard()
    this.loadInitialPayment()

    this.pageStatus = Status.Completed
  }

  isAvailablePayment(paymentId: string) {
    return this.availablePaymentList.isAvailablePayment(paymentId)
  }

  loadInitialPayment(): void {
    if (!this.payment) {
      return
    }

    const payment = this.availablePaymentList.find(p => p.id === this.payment.payment_type)
    if (!payment) {
      return
    }

    this.selected = SelectedPayment
      .createByPayment(payment)
      .update(this.payment.selectedOptionList || SelectOptionList.empty())
  }

  filterPurchasableItem(item: CartItem): boolean {
    return !(item.removed || false)
  }

  async validateAll(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  get selectedPayment(): AvailablePayment | null {
    return this.selected.payment
  }

  async submitOtherThanCreditCard() {
    // validate fields
    const validated = await this.validateAll()
    // TODO $validatorにエラーがあるように見えるがvalidatedが常にtrue
    if (!validated) {
      this.modalMessage = 'ご入力内容に不備があります。'
      this.showModal = true

      return
    }

    // validate payment type
    if (!this.paymentType) {
      this.modalMessage = 'お支払い方法が選択されていません'
      this.showModal = true

      return
    }

    if (!this.selectedPaymentTypeIsAllowed) {
      this.modalMessage = 'このお支払い方法はご利用頂けません'
      this.showModal = true

      return
    }

    /**
     * client/spa/src/components/pages/order/edit/payment/Index.vueの同様の処理のコメント参照
     * 2025/04時点で定期購入機能を利用するサービスは存在しないため、これは検証されていない実装であることに注意
     */
    if (this.paymentType === 'creditcard3d') {
      this.navigateToOrder()

      return
    }

    if (this.paymentType === 'cash-on-delivery') {
      await this.submitCashOnDelivery()

      return
    }

    if (this.paymentType === 'np-postpay') {
      await this.submitNpPostpay()

      return
    }

    if (this.paymentType === 'atone') {
      await this.submitAtone()

      return
    }

    if (this.paymentType === 'paidy') {
      await this.submitPaidy()

      return
    }

    // コンビニ決済、キャリア決済時に実装されたルート
    // それ以降に実装された決済方法は原則このルートを利用する
    // 既存の決済方法もこのルートに寄せていきたい
    await this.submitDefault()
  }

  async submitCashOnDelivery(): Promise<void> {
    const payload: WithApiPayment = {
      apiPayment: this.selectedPayment!,
    }
    await this.$store.dispatch('orderConfirm/setPaymentToCashOnDelivery', payload)

    this.navigateToOrder()
  }

  async submitNpPostpay(): Promise<void> {
    const payload: WithApiPayment = {
      apiPayment: this.selectedPayment!,
    }
    await this.$store.dispatch('orderConfirm/setPaymentToNpPostpay', payload)

    this.navigateToOrder()
  }

  async submitAtone(): Promise<void> {
    const payload: WithApiPayment = {
      apiPayment: this.selectedPayment!,
    }
    await this.$store.dispatch('orderConfirm/setPaymentToPaidy', payload)

    this.navigateToOrder()
  }

  async submitPaidy(): Promise<void> {
    const payload: WithApiPayment = {
      apiPayment: this.selectedPayment!,
    }
    await this.$store.dispatch('orderConfirm/setPaymentToPaidy', payload)

    this.navigateToOrder()
  }

  async submitDefault(): Promise<void> {
    if (this.selectedPayment === null) {
      return
    }

    const validateOptions = (new OptionsValidator(
      this.selectedPayment.parameters,
      this.selectedPaymentOptions
    )).validate()

    if (!validateOptions) {
      this.modalMessage = 'ご入力内容に不備があります。'
      this.showModal = true

      return
    }

    const payment: Payment = {
      payment_type: this.selectedPayment.id,
      apiPayment: this.selectedPayment,
      selectedOptionList: this.selectedPaymentOptions,
    }

    await this.$store.dispatch('orderConfirm/setPayment', { payment })

    this.navigateToOrder()
  }

  useCreditcard(creditcard: CreditcardModel): () => Promise<void> {
    return async () => {
      const cardPayment = this.availablePaymentList.find(p => p.isCreditCard())
      if (!(cardPayment && cardPayment.isCreditCard())) {
        throw new Error(`expected type is kind of credit card, but actual is ${cardPayment}`)
      }

      const payload: PayloadSetPaymentToCreditcard = Object.assign(creditcard.clone(), {
        token: creditcard.id,
        payment_type: cardPayment.id,
        apiPayment: cardPayment,
      })
      await this.$store.dispatch('orderConfirm/setPaymentToCreditcard', payload)

      this.navigateToOrder()
    }
  }

  removeCreditcard(creditcard: CreditcardModel): () => Promise<void> {
    return async () => {
      this.removeCardStatus = Status.Loading

      const { id } = creditcard

      await this.$store.dispatch('creditcard/remove', id)

      const errorOnRemove = _.find(this.$store.state.creditcard.items, ['id', id])

      if (errorOnRemove) {
        this.removeCardStatus = Status.Failed
        this.modalMessage = 'エラーが発生しました。<br/>クレジットカード情報が削除できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
        this.showModal = true

        return
      }

      await this.reloadCreditCard({ force: true })

      // Remove from orderConfirm if the creditcard is used
      if (this.payment && this.payment.token === id) {
        await this.$store.dispatch('orderConfirm/unsetPayment')
      }

      this.removeCardStatus = Status.Completed
    }
  }

  onPaymentSelected(payment: AvailablePayment) {
    if (!this.availablePaymentList.isAvailablePayment(payment.id)) {
      return
    }

    this.selected = SelectedPayment.createByPayment(payment)
  }

  onOptionSelected(option: SelectOption) {
    this.selected = this.selected.toggleOption(option)
  }

  navigateToNewCreditCard() {
    this.$router.push(this.context.path.addCreditCard)
  }

  onCanceled() {
    this.$router.push(this.cancelUrl)
  }

  onPaymentEditError(message: string) {
    this.modalMessage = message
    this.showModal = true
  }

  private reloadCreditCard(option: { force: boolean } = { force: false }) {
    const payload: LoadPayload = {
      ...option,
      service: this.context.factory.service.creditCard(),
    }

    return this.$store.dispatch('creditcard/load', payload)
  }

  private navigateToOrder() {
    this.$router.push(this.context.path.confirmPage)
  }

  private async fetchAvailablePaymentList() {
    const cartIdList = _.map(this.cartItems, cart => cart.id)
    const result = await this.paymentService.get(cartIdList, {
      confirm_url: `${location.origin}/s/order/subscription/${this.skuId}?scope=${toQuery(this.scope)}`,
    })

    if (result.isLeft()) {
      this.modalMessage = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      return
    }

    this.availablePaymentList = PaymentList.valueOf(result.value)
  }
}

async function guardOnCart(scope: CartScopeEq, context: OrderContext): Promise<RouteConfig | undefined> {
  await store.dispatch('cart/loadWithScope', { scope })

  const error = _.get(store.state.cart.error, 'load')

  const diplayItems: CartItem[] = store.getters['cart/displayItems']

  const totalItemCount = _.sumBy(diplayItems, item => _.toNumber(item.unitCount))

  if (error || totalItemCount === 0) {
    return {
      path: context.path.confirmPage,
    }
  }
}
